"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelectFieldLogic = void 0;
const sortBy_1 = __importDefault(require("lodash-es/sortBy"));
const isString_1 = __importDefault(require("lodash-es/isString"));
const clipboard_1 = require("../../clipboard");
const types_1 = require("@smartsuite/types");
const field_logic_1 = require("../../field-type-registry/field-logic");
const comparisons_1 = require("../../comparisons/comparisons");
const fields_1 = require("../../utils/fields");
const migration_1 = require("../../utils/migration");
const intl_1 = require("../../locale/intl");
const migrations_1 = require("../../migrations");
const migrations_2 = require("../../migrations/migrations");
const single_select_fieldtype_1 = require("../../safe-field-value/single-select-field/single-select.fieldtype");
const utils_1 = require("../../sort/utils");
const color_1 = require("../../utils/color");
const yes_no_field_1 = require("../yes-no-field");
const texts_1 = require("../../texts");
const validation_1 = require("../../validation/validation");
const choice_fields_1 = require("../../utils/choice-fields");
const type_guards_1 = require("../../utils/type-guards");
class SingleSelectFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.name = "singleselectfield";
        this.label = (0, intl_1.$t)(texts_1.singleSelectFieldText.single_select);
        this.icon = "single-select";
        this.iconColor = "#EC506E";
        this.placeholder = (0, intl_1.$t)(texts_1.singleSelectFieldText.type_or_select_value);
        this.searchSynonyms = [(0, intl_1.$t)(texts_1.singleSelectFieldText.list)];
        this.choiceMaxLength = 400;
        this.fieldValueGetter = new single_select_fieldtype_1.SingleSelectFieldValueGetter();
        // @ts-expect-error: Need to resolve
        this.comparisons = {
            is: comparisons_1.is,
            is_not: comparisons_1.isNot,
            is_empty: comparisons_1.isEmpty,
            is_not_empty: comparisons_1.isNotEmpty,
            is_any_of: comparisons_1.isAnyOf,
            is_none_of: comparisons_1.isNoneOf,
        };
        // @ts-expect-error: Need to resolve
        this.clipboardPasteRules = {
            firstcreatedfield: withOptionCreating(clipboard_1.clipboardCreatedUpdatedToSingleSelect),
            lastupdatedfield: withOptionCreating(clipboard_1.clipboardCreatedUpdatedToSingleSelect),
            linkedrecordfield: withOptionCreating(clipboard_1.clipboardReferenceFieldToSingleSelectField),
            yesnofield: withOptionCreating(clipboard_1.clipboardTextToChoice),
            singleselectfield: withOptionCreating(clipboard_1.clipboardSingleSelectSelf),
            multipleselectfield: withOptionCreating(clipboard_1.clipboardMultipleSelectToSingle),
            tagsfield: withOptionCreating(clipboard_1.clipboardMultipleSelectToSingle),
            userfield: withOptionCreating(clipboard_1.clipboardMemberToSingleSelect),
            emailfield: withOptionCreating(clipboard_1.clipboardEmailSingleSelect),
            statusfield: withOptionCreating(clipboard_1.clipboardStatusSingleSelect),
            textfield: withOptionCreating(clipboard_1.clipboardTextToChoice),
            recordtitlefield: withOptionCreating(clipboard_1.clipboardTextToChoice),
            textareafield: withOptionCreating(clipboard_1.clipboardTextToChoice),
            richtextareafield: withOptionCreating(clipboard_1.clipboardTextToChoice),
            fullnamefield: withOptionCreating(clipboard_1.clipboardFullNameToSingle),
            unknownfield: withOptionCreating(clipboard_1.clipboardTextToChoice),
        };
        this.getColoredChoices = (field) => {
            var _a;
            return (0, color_1.getColoredChoices)((_a = field.params.choices) !== null && _a !== void 0 ? _a : []);
        };
    }
    get validators() {
        const uniqueValidator = (0, validation_1.uniqueRecordFieldValueWithContext)({
            checkUniqueness: this.appRecordsService.checkUniqueness.bind(this.appRecordsService),
        });
        return {
            required: validation_1.required,
            unique: uniqueValidator,
            requiredDescriptionForOtherValue: validation_1.requiredDescriptionForOtherValue,
        };
    }
    getCssClass(field) {
        if (field.params.control_type === "radiobutton") {
            return "record-group--poll";
        }
        return "";
    }
    sortKey(fieldValue, field) {
        return (0, utils_1.getListFieldOrderValue)((0, fields_1.getFieldChoiceByValue)(field, fieldValue));
    }
    useSortCache() {
        return false;
    }
    useNaturalSorting(field, fieldValue, isGroupByRule) {
        return false;
    }
    groupByKey(fieldValue, field) {
        return this.sortKey(fieldValue, field);
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            editorWidth: "200px",
            saveKeys: ["Tab"],
            switchToInputControl: "OnSelectedCellClick",
            rollbackOnPressEscapeKey: false,
            editOnStartTyping: false,
        };
    }
    getEmptyValue() {
        return "";
    }
    migrateField(fieldTo, fieldFrom, applicationId) {
        var _a;
        let migratedField;
        if (fieldFrom.field_type === "statusfield") {
            migratedField = (0, migrations_1.migrateStatusFieldToListField)(fieldTo, fieldFrom);
        }
        else if (fieldFrom.field_type === "yesnofield") {
            migratedField = (0, yes_no_field_1.yesNoFieldToListField)(fieldTo, fieldFrom);
        }
        else if (fieldFrom.field_type === "multipleselectfield") {
            migratedField = (0, migrations_2.migrateMultipleSelectToSingleSelect)(fieldTo, fieldFrom);
        }
        else if (fieldFrom.field_type === "tagsfield") {
            migratedField = (0, migrations_2.migrateTagsFieldToListField)(fieldTo, fieldFrom, applicationId);
        }
        else {
            migratedField = (0, migrations_2.migrateBaseField)(fieldTo, fieldFrom);
        }
        return (0, migration_1.migrateDisplayFormat)(migratedField, types_1.listFieldDisplayFormats, (_a = fieldTo.params.display_format) !== null && _a !== void 0 ? _a : "");
    }
    getRecordValueFromFieldChoice(fieldChoice) {
        return fieldChoice.value;
    }
    getFilterComponentData(field, comparison) {
        return {
            ...super.getFilterComponentData(field, comparison),
            choices: field.params.choices,
        };
    }
    isValueEqual(fieldValue1, fieldValue2) {
        return (!fieldValue1 && !fieldValue2) || fieldValue1 === fieldValue2;
    }
    isGroupHighlighted(_field) {
        return true;
    }
    getChoiceByRecordValue(record, field) {
        var _a, _b;
        const recordValue = (0, fields_1.getValueFromRecordByField)(record, field);
        if ((0, isString_1.default)(recordValue)) {
            return ((_b = (_a = field.params.choices) === null || _a === void 0 ? void 0 : _a.find(({ value }) => recordValue === value)) !== null && _b !== void 0 ? _b : null);
        }
        return null;
    }
    getChoiceColor(field, choice) {
        var _a;
        if (field.params.display_format === "text_icon" &&
            choice.icon_type === "emoji") {
            return undefined;
        }
        return (_a = choice.value_color) !== null && _a !== void 0 ? _a : undefined;
    }
    getGridColumnSettings(field) {
        return {
            ...super.getGridColumnSettings(field),
            minWidth: 87,
        };
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 170,
            minWidth: 90,
        };
    }
    filterToRecordValue(filterValue, comparison, field) {
        var _a;
        const validValues = (_a = field.params.choices) === null || _a === void 0 ? void 0 : _a.map(({ value }) => value);
        if (comparison === "is" && (validValues === null || validValues === void 0 ? void 0 : validValues.includes(filterValue))) {
            return filterValue;
        }
        throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
    }
    getContentSize(fieldValue, field, userPreferences, record, font) {
        const { display_format } = field.params;
        const hasIcon = display_format === "text_icon";
        const hasDot = display_format === "importance";
        const isTextOnly = display_format === "text_only";
        const pillPadding = isTextOnly || hasIcon ? 0 : 20;
        const pillDot = hasDot ? 18 : 0;
        const pillIcon = hasIcon ? 20 : 0;
        const size = super.getContentSize(fieldValue, field, userPreferences, record, font);
        return size + pillPadding + pillDot + pillIcon;
    }
    getSpotlightColorizer(field) {
        var _a;
        const choices = (_a = field.params.choices) !== null && _a !== void 0 ? _a : [];
        const colorsMap = new Map(choices.map(({ value, value_color }) => [value, value_color]));
        return (fieldValue) => {
            var _a;
            return (_a = colorsMap.get(fieldValue)) !== null && _a !== void 0 ? _a : null;
        };
    }
    getSpotlightColorChoices(field) {
        var _a;
        const choices = (0, sortBy_1.default)((_a = field.params.choices) !== null && _a !== void 0 ? _a : [], "value_order");
        return choices.map(({ value, label, value_color }) => ({
            value,
            label,
            color: (0, type_guards_1.isNotNullOrUndefined)(value_color) ? value_color : "",
        }));
    }
    isFieldMetadataValid(newValue) {
        if (!newValue || typeof newValue !== "object") {
            return false;
        }
        const metadata = newValue;
        return ("description" in metadata &&
            typeof metadata.description === "string" &&
            metadata.description.trim() !== "");
    }
    processSearch(searchTerm, fieldValue, field, userPreferences, record) {
        if (super.processSearch(searchTerm, fieldValue, field, userPreferences, record)) {
            return true;
        }
        return this.processSearchInFieldMetadata(searchTerm, field, record);
    }
    processSearchInFieldMetadata(searchTerm, field, record) {
        const preparedTerm = this.prepareSearchTerm(searchTerm);
        const metadata = this.getFieldMetadata(field, record);
        if (!preparedTerm || !(metadata === null || metadata === void 0 ? void 0 : metadata.description))
            return false;
        return metadata.description.toLowerCase().includes(preparedTerm);
    }
}
exports.SingleSelectFieldLogic = SingleSelectFieldLogic;
const withOptionCreating = (fn) => {
    return async (...args) => {
        var _a, _b, _c;
        const [clipboardValue, srcField, targetField, userPreferences, currentValue, extra,] = args;
        const choiceValue = fn(clipboardValue, srcField, targetField, userPreferences, currentValue, extra);
        if (((extra === null || extra === void 0 ? void 0 : extra.canMigrateField) ||
            targetField.params.new_choices_allowed) &&
            choiceValue === clipboardValue.text) {
            const field = await ((_a = extra === null || extra === void 0 ? void 0 : extra.fieldsService) === null || _a === void 0 ? void 0 : _a.createFieldChoices(extra.applicationId, targetField, [(0, choice_fields_1.getChoicesWithParams)([clipboardValue.text], srcField)[0]]));
            return await Promise.resolve((_c = (_b = field.params.choices) === null || _b === void 0 ? void 0 : _b.find(({ label }) => label === clipboardValue.text)) === null || _c === void 0 ? void 0 : _c.value);
        }
        return await Promise.resolve(choiceValue);
    };
};
